import React, { Component } from "react";
import {  Modal } from "react-bootstrap";
import VolumeFoliosList from "containers/property/VolumeFoliosList";


export default class VolumeFoliosModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
        };
    }
    
    async componentDidMount() {
        console.log("In VolumeFoliosModal componentDidMount");

        if (!this.props.isAuthenticated) { // if false
            return;
        }

        if (!this.props.show) {
            return null;
        }  
    }

    componentWillUnmount() {
        this.setState({ entities: [] });
    }

    renderVolumeFolios() {
        return (
            <Modal
                show={this.props.show}
                onHide={this.props.toggleVolumeFoliosModal}
                dialogClassName="modal-90w"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Volume Folio Details</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ 'overflowX': 'scroll' }}>
                    <VolumeFoliosList
                        filter={this.props.filter}
                        isAuthenticated={this.props.isAuthenticated}
                        isLoading={this.state.isLoading}
                        controlType="table"
                        saveForm={this.props.saveForm}
                        user={this.props.user}
                        data={this.props.data}
                        dataFetch={this.props.dataFetch}
                        updateTableState={this.props.updateTableState}
                        saveRecord={this.props.saveRecord}
                        deleteRecord={this.props.deleteRecord}
                        validateRelatedRecord={this.props.validateRelatedRecord}
                        streetOptions={this.props.streetOptions}
                        context={this.props.context}
                    />
                </Modal.Body>
            </Modal>
        );
    }
    
    render() {
        return (
            <div className="VolumeFoliosEdit">
                {this.props.isAuthenticated ? this.renderVolumeFolios() : console.log("error)")}
            </div>
        );
    }
}
